<nav class="breadcrumbs" aria-label="breadcrumb">
    <ol>
        <li *ngFor="let c of crumbs; let last = last">
            <a *ngIf="!last" [routerLink]="c.url">{{ c.label }}</a>
            <span *ngIf="last" aria-current="page">{{ c.label }}</span>
            <mat-icon *ngIf="!last" class="sep" inline>chevron_right</mat-icon>
        </li>
    </ol>
</nav>